import type { Location } from "../types";

export const sortByNumber = (a: Location, b: Location) =>
  parseInt(a.locationNumber) - parseInt(b.locationNumber);

export const sortByName = (a: Location, b: Location) => {
  if (a.core.locationName > b.core.locationName) return 1;
  if (a.core.locationName < b.core.locationName) return -1;
  return sortByNumber(a, b);
};

export const sortByCity = (a: Location, b: Location) => {
  if (a.core.physicalAddress.city > b.core.physicalAddress.city) return 1;
  if (a.core.physicalAddress.city < b.core.physicalAddress.city) return -1;
  return sortByName(a, b);
};

export const sortByState = (a: Location, b: Location) => {
  if (a.core.physicalAddress.state > b.core.physicalAddress.state) return 1;
  if (a.core.physicalAddress.state < b.core.physicalAddress.state) return -1;
  return sortByName(a, b);
};

export const sortByRegion = (a: Location, b: Location) => {
  const comparison =
    parseInt(a.fieldOpsHierarchy.regionCode) -
    parseInt(b.fieldOpsHierarchy.regionCode);
  return comparison === 0 ? sortByName(a, b) : comparison;
};

export const sortBySelectionTimeline = (a: Location, b: Location) => {
  if (
    a.franchiseOpportunity.operatorSelectionTimeline >
    b.franchiseOpportunity.operatorSelectionTimeline
  )
    return 1;
  if (
    a.franchiseOpportunity.operatorSelectionTimeline <
    b.franchiseOpportunity.operatorSelectionTimeline
  )
    return -1;
  return sortByName(a, b);
};

export const sortBySelectionDate = (a: Location, b: Location) => {
  const date1Time = new Date(
    a.franchiseOpportunity.recruitPhase5Date,
  ).getTime();
  const date2Time = new Date(
    b.franchiseOpportunity.recruitPhase5Date,
  ).getTime();
  if (date1Time > date2Time) return 1;
  if (date1Time < date2Time) return -1;
  return sortByName(a, b);
};
